import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Login from '../modules/App/components/LogInForm';
import ForgotPassword from '../modules/App/components/ForgotPasswordForm';
import ResetPassword from '../modules/App/components/ResetPasswordForm';
import EmailConfirmation from '../modules/App/components/EmailConfirmation';

const account_routes = [
    { path: '/login', component: Login },
    { path: '/auth/reset-password', component: ResetPassword },
    { path: '/auth/forgot-password', component: ForgotPassword },
    { path: '/user/verify-account/', component: EmailConfirmation },
];

export const AuthRouter = () => (
    <BrowserRouter>
        <Switch>
            {account_routes.map((account_route, index) => <Route key={index} exact path={account_route.path} component={account_route.component} />)}
        </Switch>
    </BrowserRouter>
);



// WEBPACK FOOTER //
// ./src/router/AuthRouter.js